import { SectionTitle } from "../Form/Form";
import { t } from "i18next";
import styled from "styled-components";
import { ToggleSwitchV2 } from "../ToggleSwitch/ToggleSwitch";
import { Card } from "../../layout/publicPageLayout";
import { TUserNotificationsPreferences } from "./user_notif_util";
import { Dispatch, SetStateAction } from "react";
import { spacingTokens } from "../../designTokens";

const ToggleSwitchWrapper = styled.div`
  margin: ${({ theme }) => theme.resolve("spacing_2xl")} 0;
`;

export function UserNotifications({
  userNotifications,
  setUserNotifications,
  show_transactions = true,
}: {
  userNotifications: TUserNotificationsPreferences;
  setUserNotifications: Dispatch<SetStateAction<TUserNotificationsPreferences>>;
  show_transactions?: boolean;
}) {
  const handleMainToggle = (type: "leads" | "transactions") => {
    if (type === "leads") {
      const newValue = !userNotifications.leads;
      setUserNotifications({
        ...userNotifications,
        leads: newValue,
        leads_enable_quote_request: newValue,
        leads_enable_sample_request: newValue,
        leads_enable_registration: newValue,
        leads_enable_contact_us: newValue,
      });
    } else {
      const newValue = !userNotifications.transactions;
      setUserNotifications({
        ...userNotifications,
        transactions: newValue,
        transactions_enable_order: newValue,
        transactions_enable_sample_request: newValue,
        transactions_enable_quote_request: newValue,
      });
    }
  };

  const handleSubToggle = (field: keyof TUserNotificationsPreferences) => {
    if (field.startsWith("leads_")) {
      const updatedNotifications = {
        ...userNotifications,
        [field]:
          !userNotifications[field as keyof TUserNotificationsPreferences],
      };

      // Update main toggle based on sub-toggles
      updatedNotifications.leads =
        updatedNotifications.leads_enable_quote_request ||
        updatedNotifications.leads_enable_sample_request ||
        updatedNotifications.leads_enable_registration ||
        updatedNotifications.leads_enable_contact_us;

      setUserNotifications(updatedNotifications);
    } else if (field.startsWith("transactions_")) {
      const updatedNotifications = {
        ...userNotifications,
        [field]:
          !userNotifications[field as keyof TUserNotificationsPreferences],
      };

      // Update main toggle based on sub-toggles
      updatedNotifications.transactions =
        updatedNotifications.transactions_enable_order ||
        updatedNotifications.transactions_enable_sample_request ||
        updatedNotifications.transactions_enable_quote_request;

      setUserNotifications(updatedNotifications);
    }
  };

  return (
    <>
      <SectionTitle style={{ margin: "30px 0 3px" }}>
        {t("Notification Preferences")}
      </SectionTitle>
      <ToggleSwitchWrapper
        style={{ margin: `${spacingTokens.spacing_2xl} 0 15px` }}
      >
        <ToggleSwitchV2
          label={t("Leads")}
          name={"leads_notification"}
          checked={userNotifications.leads}
          onChange={() => handleMainToggle("leads")}
        />
      </ToggleSwitchWrapper>

      {userNotifications.leads && (
        <Card style={{ background: "#fff", padding: "5px 15px" }}>
          <ToggleSwitchWrapper>
            <ToggleSwitchV2
              label={t("Quote Request")}
              name={"leads_enable_quote_request"}
              checked={userNotifications.leads_enable_quote_request}
              onChange={() => handleSubToggle("leads_enable_quote_request")}
            />
          </ToggleSwitchWrapper>
          <ToggleSwitchWrapper>
            <ToggleSwitchV2
              label={t("Sample Request")}
              name={"leads_enable_sample_request"}
              checked={userNotifications.leads_enable_sample_request}
              onChange={() => handleSubToggle("leads_enable_sample_request")}
            />
          </ToggleSwitchWrapper>
          <ToggleSwitchWrapper>
            <ToggleSwitchV2
              label={t("Register")}
              name={"leads_enable_registration"}
              checked={userNotifications.leads_enable_registration}
              onChange={() => handleSubToggle("leads_enable_registration")}
            />
          </ToggleSwitchWrapper>
          <ToggleSwitchWrapper>
            <ToggleSwitchV2
              label={t("Contact Us")}
              name={"leads_enable_contact_us"}
              checked={userNotifications.leads_enable_contact_us}
              onChange={() => handleSubToggle("leads_enable_contact_us")}
            />
          </ToggleSwitchWrapper>
        </Card>
      )}
      {show_transactions && (
        <>
          <ToggleSwitchWrapper
            style={{ margin: `${spacingTokens.spacing_2xl} 0 15px` }}
          >
            <ToggleSwitchV2
              label={t("Transactions")}
              name={"transactions_notification"}
              checked={userNotifications.transactions}
              onChange={() => handleMainToggle("transactions")}
            />
          </ToggleSwitchWrapper>
          {userNotifications.transactions && (
            <Card style={{ background: "#fff", padding: "5px 15px" }}>
              <ToggleSwitchWrapper>
                <ToggleSwitchV2
                  label={t("Quote Request")}
                  name={"transactions_enable_quote_request"}
                  checked={userNotifications.transactions_enable_quote_request}
                  onChange={() =>
                    handleSubToggle("transactions_enable_quote_request")
                  }
                />
              </ToggleSwitchWrapper>
              <ToggleSwitchWrapper>
                <ToggleSwitchV2
                  label={t("Sample Request")}
                  name={"transactions_enable_sample_request"}
                  checked={userNotifications.transactions_enable_sample_request}
                  onChange={() =>
                    handleSubToggle("transactions_enable_sample_request")
                  }
                />
              </ToggleSwitchWrapper>
              <ToggleSwitchWrapper>
                <ToggleSwitchV2
                  label={t("Order")}
                  name={"transactions_enable_order"}
                  checked={userNotifications.transactions_enable_order}
                  onChange={() => handleSubToggle("transactions_enable_order")}
                />
              </ToggleSwitchWrapper>
            </Card>
          )}
        </>
      )}
    </>
  );
}
